import { useState } from "react";
import BankConsumer from "./BankConsumer";

const useGetBank = () => {
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);

    const loadBank = (iban: string) => {
        setLoading(true);

        return BankConsumer.getBank(iban)
            .then(resp => {
                setError(false);
                return resp.bank;
            }).catch(error => {
                setError(true);
                return undefined
            }).finally(() => {
                setLoading(false);
            })
    }

    return {
        loading,
        error,
        loadBank
    }

}

export default useGetBank;